/* dnb-bundle-swap.js — "Get both" upsell on the Coffee+ / Cocoa+ PDPs (2026-09).
   Loaded only by sections/dnb-pdp-hero.liquid (defer). Reads #dnb-pdp-data (product data
   emitted by Liquid, no price literals) and window.dnbPriceState (snippets/dnb-price-sync).

   Two card states, following the design:
     - bundle tier selected  -> "Get both": posts the Day & Night Bundle exactly the way
       Loop's own widget does (two children, "(Bundle)" plan, shared _bundleId, discount
       attributes), REPLACING this product's plain line(s) in the cart. The cart drawer then
       shows a notice with Undo. Gifts arrive through the guard in custom.js like any bundle.
     - any other tier        -> "Add <other>": a plain add of the other product's bundle-tier
       pouch on the same plan type. No swap, no notice.

   Undo shows ONLY for a bundle that was added from one of these PDPs (its id is kept in
   sessionStorage). Bundles added on the bundle PDP itself never get an Undo notice. */
(function () {
  'use strict';
  if (window.__dnbSwapBound) return;
  window.__dnbSwapBound = true;

  var STORE_KEY = 'dnb_swap';
  var dataEl = document.getElementById('dnb-pdp-data');
  var data = null;
  try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { data = null; }

  function fmt(c) {
    if (typeof window.dnbFmtMoney === 'function') return window.dnbFmtMoney(c);
    return '$' + (c / 100).toFixed(2);
  }
  function days(name) { var m = /(\d+)\s*day/i.exec(name || ''); return m ? parseInt(m[1], 10) : null; }
  function tpl(s, map) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function readStore() { try { var v = sessionStorage.getItem(STORE_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function writeStore(v) { try { if (v) sessionStorage.setItem(STORE_KEY, JSON.stringify(v)); else sessionStorage.removeItem(STORE_KEY); } catch (e) {} }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) { throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status)); } return j; }); });
  }
  function refreshCart(open) {
    var cd = document.querySelector('cart-drawer');
    if (open && cd && typeof cd.openCartDrawer === 'function') cd.openCartDrawer();
    var ci = document.querySelector('cart-items');
    if (ci && typeof ci.getCart === 'function') ci.getCart();
  }
  /* Crockford base32 ULID, same shape Loop uses for _bundleId. */
  function ulid() {
    var A = '0123456789ABCDEFGHJKMNPQRSTVWXYZ', t = Date.now(), out = '';
    for (var i = 0; i < 10; i++) { out = A[t % 32] + out; t = Math.floor(t / 32); }
    var rnd = new Uint8Array(16);
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(rnd); else for (var j = 0; j < 16; j++) rnd[j] = Math.floor(Math.random() * 256);
    for (var k = 0; k < 16; k++) out += A[rnd[k] % 32];
    return out;
  }
  /* `live` (optional) is the set of _bundleId values still present on cart lines: keys for
     bundles that are no longer in the cart are dropped so the attribute cannot grow forever
     across swaps and undos. Entries for bundles still in the cart are always kept as-is. */
  function mergeDiscountAttr(existing, id, entry, live) {
    var map = {};
    try { map = existing ? JSON.parse(existing) : {}; } catch (e) { map = {}; }
    if (!map || typeof map !== 'object') map = {};
    if (live) Object.keys(map).forEach(function (k) { if (k !== id && !live[k]) delete map[k]; });
    if (entry) map[id] = entry; else delete map[id];
    return JSON.stringify(map);
  }
  function liveBundleIds(cart) {
    var live = {};
    (cart && cart.items || []).forEach(function (it) { var p = it.properties || {}; if (p._bundleId) live[p._bundleId] = true; });
    return live;
  }

  /* ================= Upsell card on the PDP ================= */
  var card = document.querySelector('[data-dnb-upsell]');
  var btns = Array.prototype.slice.call(document.querySelectorAll('[data-dnb-up-btn]'));
  var idInput = document.querySelector('#dnb-form [name="id"]');
  var qtyInput = document.querySelector('#dnb-form [name="quantity"]');
  var mode = null; /* {kind:'bundle'|'single', ...} computed from the current selection */

  function priceState() { return window.dnbPriceState || null; }
  function currentTier() {
    if (!data || !idInput) return null;
    var id = String(idInput.value);
    for (var i = 0; i < data.tiers.length; i++) if (String(data.tiers[i].id) === id) return data.tiers[i];
    return null;
  }
  function pickByDays(list, freq, fallbackFirst) {
    if (!list || !list.length) return null;
    var d = days(freq);
    if (d != null) for (var i = 0; i < list.length; i++) if (days(list[i].name) === d) return list[i];
    return fallbackFirst ? list[0] : null;
  }

  function computeMode() {
    if (!data || !data.other || data.other.available === false) return null;
    var tier = currentTier(); if (!tier || tier.available === false) return null;
    /* No price state yet (Loop still loading, or absent): show nothing rather than guess a plan. */
    var ps = priceState(); if (!ps || !ps.plan) return null;
    var plan = ps.plan;
    var freq = ps.freq;
    var t = data.text || {};
    var b = data.bundle;
    if (b && String(tier.id) === String(b.thisVariantId)) {
      var bplan = pickByDays(b.plans, freq, true);
      if (plan === 'sub' && bplan) {
        var save = b.separateSub - b.sub;
        /* The bundle has its own set of cadences; say so when it cannot match the one chosen. */
        var bd = days(bplan.name), fdays = days(freq);
        var cadence = (bd != null && fdays != null && bd !== fdays) ? ' Delivered every ' + bd + ' days.' : '';
        /* Gift count comes from the theme setting the cart guard reads (window.DNB_GIFT_VARIANTS), so an
           empty gift list drops the claim automatically. */
        var gifts = (window.DNB_GIFT_VARIANTS && window.DNB_GIFT_VARIANTS.length) || 0;
        var extra = gifts > 0 ? ', plus ' + gifts + ' free gift' + (gifts === 1 ? '' : 's') : (save > 0 ? ', ' + fmt(save) + ' less than separately' : '');
        return { kind: 'bundle', plan: 'sub', planId: bplan.id, price: b.sub, save: save,
          title: t.bundleTitle, cta: tpl(t.bundleCta, { price: fmt(b.sub) + '/mo' }),
          body: fmt(b.sub) + '/mo for both' + extra + '. ' + fmt(b.otp) + ' one-time.' + cadence };
      }
      var otpSave = (tier.price + data.other.price) - b.otp;
      return { kind: 'bundle', plan: 'otp', planId: null, price: b.otp, save: otpSave,
        title: t.bundleTitle, cta: tpl(t.bundleCta, { price: fmt(b.otp) }),
        body: fmt(b.otp) + ' for both, one-time' + (otpSave > 0 ? ', ' + fmt(otpSave) + ' less than separately' : '') + '. ' + fmt(b.sub) + '/mo with subscription.' };
    }
    var o = data.other;
    var cups = o.cups ? o.cups + ' cups of ' : '';
    var sub = pickByDays(o.subs, freq, true);
    if (plan === 'sub' && sub) {
      var sd = days(sub.name), fd2 = days(freq);
      var cad2 = (sd != null && fd2 != null && sd !== fd2) ? ' Delivered every ' + sd + ' days.' : '';
      return { kind: 'single', plan: 'sub', planId: sub.id, price: sub.price, save: 0, title: t.singleTitle,
        cta: tpl(t.singleCta, { price: fmt(sub.price) + '/mo' }),
        body: cups + o.label + ' at ' + fmt(sub.price) + '/mo on this plan. ' + fmt(o.price) + ' one-time.' + cad2 };
    }
    return { kind: 'single', plan: 'otp', planId: null, price: o.price, save: 0, title: t.singleTitle,
      cta: tpl(t.singleCta, { price: fmt(o.price) }),
      body: cups + o.label + ', ' + fmt(o.price) + ' one-time.' + (sub ? ' ' + fmt(sub.price) + '/mo with subscription.' : '') };
  }

  function renderCard() {
    if (!card) return;
    mode = computeMode();
    if (!mode) { card.hidden = true; return; }
    var title = card.querySelector('[data-dnb-up-title]');
    var save = card.querySelector('[data-dnb-up-save]');
    if (title) title.textContent = mode.title || '';
    if (save) { if (mode.kind === 'bundle' && mode.save > 0) { save.textContent = 'Save ' + fmt(mode.save) + ' more'; save.hidden = false; } else { save.hidden = true; } }
    /* Card body AND the peek modal's price line: the one-time price must sit next to the /mo price everywhere. */
    document.querySelectorAll('[data-dnb-up-body]').forEach(function (body) { body.textContent = mode.body; });
    btns.forEach(function (b) { b.textContent = mode.cta; });
    card.hidden = false;
  }
  document.addEventListener('dnb:price', renderCard);
  document.addEventListener('dnb:variant', function () { setTimeout(renderCard, 50); });
  renderCard();
  /* Loop can finish rendering after us; the price event covers that. A late tick
     covers the no-Loop fallback where no event ever fires. */
  setTimeout(renderCard, 1500);

  var busy = false;
  function setBusy(v) { busy = v; btns.forEach(function (b) { b.disabled = v; b.setAttribute('aria-busy', v ? 'true' : 'false'); }); }
  function fail(msg) {
    document.querySelectorAll('[data-dnb-up-body]').forEach(function (body) { body.textContent = msg || 'Something went wrong adding that. Please try again.'; });
  }

  /* Bundle swap, shared by the upsell card and the "Day | Night Bundle" section further down
     the page (sections/bundle-section.liquid defers to window.dnbBundleSwap when present, so
     both buttons behave identically in the cart: replace this product's line, add the bundle,
     show the Undo notice). `m` is a snapshot {planId, save}; `onFail(msg)` reports errors. */
  function runBundleSwap(m, onFail) {
    var b = data.bundle;
    var bundleId = ulid();
    var removed = [];
    var removedApplied = false;
    var restoreFallback = { id: idInput ? String(idInput.value) : null, quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) };
    var ps = priceState();
    if (ps && ps.plan === 'sub' && ps.planId) restoreFallback.selling_plan = String(ps.planId);
    window.dnbQuietCart = true;
    var attrsBefore = null, live = null, hadBundle = false;
    return getCart()
      .then(function (cart) {
        attrsBefore = (cart.attributes || {})._loopBundleDiscountAttributes || null;
        live = liveBundleIds(cart);
        var updates = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._bundleId && !p._bundleGift && (String(it.product_id) === String(data.productId) || String(it.variant_id) === String(b.otherVariantId))) hadBundle = true;
          if (String(it.product_id) === String(data.productId) && !p._bundleId && !p._bundleGift) {
            updates[it.key] = 0;
            var r = { id: it.variant_id, quantity: it.quantity };
            if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) r.selling_plan = it.selling_plan_allocation.selling_plan.id;
            var props = {}; var hasProps = false;
            Object.keys(p).forEach(function (k) { props[k] = p[k]; hasProps = true; });
            if (hasProps) r.properties = props;
            removed.push(r);
          }
        });
        if (Object.keys(updates).length) return post('/cart/update.js', { updates: updates }).then(function () { removedApplied = true; });
        return null;
      })
      .then(function () {
        var props = { _bundleId: bundleId, _isPresetBundleProduct: true, _bundleName: b.title };
        var items = [
          { id: b.thisVariantId, quantity: 1, properties: props },
          { id: b.otherVariantId, quantity: 1, properties: props }
        ];
        if (m.planId) items.forEach(function (i) { i.selling_plan = m.planId; });
        var attrs = { _loopBundleDiscountAttributes: mergeDiscountAttr(attrsBefore, bundleId, { discountType: 'FIXED', discountValue: 0, discountComputedValue: 0 }, live) };
        return post('/cart/add.js', { items: items, attributes: attrs });
      })
      .then(function () {
        /* Undo puts back what was replaced. Nothing replaced: from an empty cart, Undo swaps the
           bundle for this product alone (the shopper came for it); when a bundle with these pouches
           was already in the cart, Undo just removes the extra bundle (adding a lone pouch next to
           the remaining bundle would be a surprise, QA 2026-09-03). */
        var restore = removed.length ? removed : (hadBundle ? [] : [restoreFallback]);
        writeStore({ bundleId: bundleId, origin: data.productId, label: data.label, bundleTitle: b.title, save: m.save, replaced: removed.length > 0, bare: !removed.length && hadBundle, restore: restore, ts: Date.now() });
        window.dnbQuietCart = false;
        refreshCart(true);
        document.dispatchEvent(new CustomEvent('dnb:swap:done'));
        verifyGifts(bundleId);
        return true;
      })
      .catch(function (e) {
        window.dnbQuietCart = false;
        /* The add failed after the old line was removed: put it back so the cart is
           never silently emptied. */
        var p = (removedApplied && removed.length) ? post('/cart/add.js', { items: removed }).catch(function () {}) : Promise.resolve();
        return p.then(function () { refreshCart(false); onFail(); return false; });
      });
  }

  function doAdd() {
    if (busy || !mode || !data) return;
    /* Snapshot: renderCard() can replace `mode` while the requests are in flight. */
    var m = mode;
    setBusy(true);
    if (m.kind === 'single') {
      var item = { id: data.other.variantId, quantity: 1 };
      if (m.planId) item.selling_plan = m.planId;
      /* Plain add: the fetch hook in dnb-price-sync opens the drawer and refreshes it. */
      post('/cart/add.js', { items: [item] })
        .then(function () { document.dispatchEvent(new CustomEvent('dnb:swap:done')); })
        .catch(function (e) { fail(); })
        .then(function () { setBusy(false); });
      return;
    }
    runBundleSwap(m, fail).then(function () { setBusy(false); });
  }

  /* Entry point for the "Day | Night Bundle" section's Add To Cart. That section always shows
     the subscription bundle price, so it always adds the subscription bundle, on the shopper's
     chosen frequency when the bundle has it (otherwise the bundle's first plan). */
  window.dnbBundleSwap = function (btn, onFail) {
    var b = data && data.bundle;
    if (!b || !b.plans || !b.plans.length) return Promise.resolve(false);
    if (busy) return Promise.resolve(null); /* another add is in flight; ignore the click */
    var ps = priceState();
    var bplan = pickByDays(b.plans, ps ? ps.freq : null, true);
    var m = { kind: 'bundle', plan: 'sub', planId: bplan.id, price: b.sub, save: b.separateSub - b.sub };
    setBusy(true);
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return runBundleSwap(m, onFail || function () {}).then(function (ok) {
      setBusy(false);
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      return ok;
    });
  };

  btns.forEach(function (b) { b.addEventListener('click', doAdd); });

  /* The gift guard in custom.js re-checks the cart after every write, but skips a pass if
     one is already running. Two quick writes (remove, then add) can land in that gap on a
     slow connection, so verify the gifts landed and nudge once if not. */
  function verifyGifts(bundleId) {
    var wanted = (window.DNB_GIFT_VARIANTS && window.DNB_GIFT_VARIANTS.length) ? window.DNB_GIFT_VARIANTS.length : 0;
    if (!wanted) return;
    var nudged = false;
    function check(attempt) {
      getCart().then(function (cart) {
        var mine = 0, anyGift = 0;
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._bundleGift) { anyGift++; if (p._bundleId === bundleId) mine++; }
        });
        /* One gift set per cart: if another bundle already owns the set, none are expected here. */
        if (mine >= wanted || (anyGift > 0 && mine === 0)) return;
        if (!nudged) { nudged = true; post('/cart/update.js', { updates: {} }).catch(function () {}); }
        if (attempt < 2) setTimeout(function () { check(attempt + 1); }, 1600);
      }).catch(function () {});
    }
    setTimeout(function () { check(0); }, 1400);
  }

  /* ================= Cart notice + Undo (runs on every page that has cart-items) ================= */
  var STYLE = '.dnb-swapnote{display:flex;gap:11px;align-items:flex-start;background:#eef7ff;padding:14px 20px;border-bottom:1px solid #e4e4e4;font-family:Nunito,sans-serif;color:#272727}' +
    '.dnb-swapnote svg{flex-shrink:0;color:#1c6df4;margin-top:2px}' +
    '.dnb-swapnote__text{display:flex;flex-direction:column;gap:4px;min-width:0}' +
    '.dnb-swapnote__t{font-weight:700;font-size:15px;line-height:1.3}' +
    '.dnb-swapnote__b{font-size:14px;line-height:1.35}' +
    '.dnb-swapnote__undo{align-self:flex-start;background:none;border:0;padding:8px 0;margin:-4px 0 0;font-family:inherit;font-weight:700;font-size:14px;color:#1c6df4;cursor:pointer;text-decoration:underline;min-height:44px}' +
    '.dnb-swapnote__undo[disabled]{opacity:.6;cursor:progress}';
  function styleOnce() {
    if (document.getElementById('dnb-swapnote-style')) return;
    var s = document.createElement('style'); s.id = 'dnb-swapnote-style'; s.textContent = STYLE;
    (document.head || document.documentElement).appendChild(s);
  }
  function noticeHtml(rec) {
    var t = (data && data.text) || {};
    var title = rec.replaced ? (t.swapped || 'Switched to the bundle') : ((rec.bundleTitle || 'Bundle') + ' added to your cart');
    var body;
    if (rec.replaced && rec.save > 0) body = tpl(t.swappedBody || 'Your {label} item was replaced, and you saved {save}.', { label: rec.label, save: fmt(rec.save) });
    else if (rec.replaced) body = 'Your ' + rec.label + ' item was replaced.';
    else if (rec.save > 0) body = 'You saved ' + fmt(rec.save) + ' vs buying the two separately.';
    else body = 'Both pouches, one delivery.';
    var undo = rec.bare ? (t.undoBare || 'Undo, remove this bundle') : tpl(t.undo || 'Undo, keep {label} only', { label: rec.label });
    var div = document.createElement('div');
    div.className = 'dnb-swapnote'; div.setAttribute('data-dnb-swapnote', rec.bundleId); div.setAttribute('role', 'status');
    div.innerHTML = '<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 169.9L227.5 327.4c-6.2 6.2-16.4 6.2-22.6 0l-70.5-70.5c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.2 59.2 138.8-138.8c6.2-6.2 16.4-6.2 22.6 0s6.3 16.4 0 22.6z"/></svg>' +
      '<div class="dnb-swapnote__text"><span class="dnb-swapnote__t"></span><span class="dnb-swapnote__b"></span><button type="button" class="dnb-swapnote__undo" data-dnb-undo></button></div>';
    div.querySelector('.dnb-swapnote__t').textContent = title;
    div.querySelector('.dnb-swapnote__b').textContent = body;
    div.querySelector('[data-dnb-undo]').textContent = undo;
    return div;
  }
  function renderNotice() {
    var rec = readStore();
    var holders = document.querySelectorAll('cart-items');
    var present = rec && document.querySelector('[data-dnb-bundle="' + rec.bundleId + '"]');
    document.querySelectorAll('[data-dnb-swapnote]').forEach(function (n) {
      if (!rec || n.getAttribute('data-dnb-swapnote') !== rec.bundleId || !present) n.remove();
    });
    if (!rec) return;
    /* Bundle not in the rendered cart (removed, checked out, still loading): no notice.
       The record is harmless to keep; a new swap always overwrites it. */
    if (!present) return;
    styleOnce();
    holders.forEach(function (h) {
      var prev = h.previousElementSibling;
      if (prev && prev.getAttribute && prev.getAttribute('data-dnb-swapnote') === rec.bundleId) return;
      h.parentNode.insertBefore(noticeHtml(rec), h);
    });
  }
  document.addEventListener('theme:cart:change', function () { setTimeout(renderNotice, 0); });
  document.addEventListener('theme:cart-drawer:open', function () { setTimeout(renderNotice, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderNotice); else renderNotice();
  setTimeout(renderNotice, 1200);

  var undoBusy = false;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-dnb-undo]') : null;
    if (!btn || undoBusy) return;
    e.preventDefault();
    var rec = readStore(); if (!rec) { btn.closest('[data-dnb-swapnote]') && btn.closest('[data-dnb-swapnote]').remove(); return; }
    undoBusy = true; btn.disabled = true;
    window.dnbQuietCart = true;
    /* Order matters: put the original line back FIRST, then remove the bundle. If the
       re-add fails (sold out), the bundle stays and the notice stays; the cart is never
       left empty. */
    var items = (rec.restore || []).filter(function (r) { return r && r.id; }).map(function (r) {
      var it = { id: r.id, quantity: r.quantity || 1 };
      if (r.selling_plan) it.selling_plan = r.selling_plan;
      if (r.properties) it.properties = r.properties;
      return it;
    });
    (items.length ? post('/cart/add.js', { items: items }) : Promise.resolve())
      .then(function () { return getCart(); })
      .then(function (cart) {
        var updates = {};
        var live = liveBundleIds(cart);
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._bundleId === rec.bundleId) updates[it.key] = 0;
        });
        delete live[rec.bundleId];
        var body = { updates: updates };
        var existing = (cart.attributes || {})._loopBundleDiscountAttributes;
        if (existing) body.attributes = { _loopBundleDiscountAttributes: mergeDiscountAttr(existing, rec.bundleId, null, live) };
        if (!Object.keys(updates).length && !body.attributes) return null;
        return post('/cart/update.js', body);
      })
      .then(function () { writeStore(null); })
      .catch(function () { /* leave the record so the notice can be retried */ })
      .then(function () {
        window.dnbQuietCart = false;
        undoBusy = false;
        refreshCart(true);
        setTimeout(renderNotice, 0);
      });
  }, true);
})();
